import { render, staticRenderFns } from "./CalendarYear.vue?vue&type=template&id=6cff112f&scoped=true&"
import script from "./CalendarYear.vue?vue&type=script&lang=js&"
export * from "./CalendarYear.vue?vue&type=script&lang=js&"
import style0 from "./CalendarYear.vue?vue&type=style&index=0&id=6cff112f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff112f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
